module["exports"] = [
  "Limpopo",
  "Gauteng",
  "Free State,",
  "North West",
  "Northern Cape",
  "Western Cape,",
  "KwaZulu-Natal",
  "Mpumalanga",
  "Eastern Cape"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_ZA/address/state.js
// module id = 2772
// module chunks = 1609